import * as cityActions from '../actions/Cities';

const initialState = {
  listCities: [
    {
      cityId: 0,
      prefCode: '1',
      cityCode: '01100',
      bigCityFlag: 0,
      cityName: '札幌市'
    }
  ]
};

const cities = (state = initialState, action) => {
  switch (action.type) {
    case cityActions.GET_CITIES_SUCCESS:
      return Object.assign({}, state, {
        listCities: action.payload
      });
    case cityActions.GET_CITIES_FAILURE:
      return Object.assign({}, state, {
        status: action.payload,
        error: action.error
      });
    default:
      return state;
  }
};

export default cities;
